<template><div><h1>base64</h1>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { base64 } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

base64.encode(<span class="hljs-string">'VUX'</span>)
base64.decode(<span class="hljs-string">'VlVY'</span>)
</code></pre>
</div></template><script>
export default {
  head: {"title":"base64 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// base64-303.vue?27bea962